import styled from "@emotion/styled"
import MuiAccordion from "@mui/material/Accordion"
import MuiAccordionSummary from "@mui/material/AccordionSummary"
import MuiAccordionDetails from "@mui/material/AccordionDetails"

export const CustomAccordion = styled(MuiAccordion)`
  background-color: ${({ theme }) => theme.palette.primary.light};

  &.MuiPaper-root {
    border-radius: 16px !important;
    margin-bottom: 1rem;

    &:before {
      background-color: transparent;
    }
  }

  /* &.MuiPaper-elevation {
    box-shadow: none;
  } */

  /* ${({ theme }) => theme.breakpoints.down("md")} {
    .MuiAccordionSummary-root {
      justify-content: space-between;
      align-items: center;

      svg {
        width: 25px !important;
        height: 25px !important;
      }
    }
  } */

  /* .MuiAccordionSummary-expandIconWrapper {
    .MuiSvgIcon-root {
      transform: rotate(0) !important;
    }
  } */

  /* .MuiAccordionDetails-root {
    padding: 0;
  } */
`

export const CustomAccSummary = styled(MuiAccordionSummary)`
  padding: 16px;
  font-size: ${({ theme }) => theme.typography.pxToRem(20)};
  line-height: ${({ theme }) => theme.typography.pxToRem(32)};
  font-weight: 500;
  color: ${({ theme }) => theme.palette.primary.dark};

  .MuiAccordionSummary-content {
    letter-spacing: 0;
    margin: 0 !important;
  }

  &.active {
    color: ${({ theme }) => theme.palette.tertiary.dark} !important;
  }

  ${({ theme }) => theme.breakpoints.up("md")} {
    font-size: ${({ theme }) => theme.typography.pxToRem(20)};
    line-height: ${({ theme }) => theme.typography.pxToRem(30)};
    padding: 24px 28px;
  }
`

export const CustomAccDetails = styled(MuiAccordionDetails)`
  padding-top: 4px;
  p,
  li {
    font-size: ${({ theme }) => theme.typography.pxToRem(17)};
    line-height: ${({ theme }) => theme.typography.pxToRem(28)};
    color: ${({ theme }) => theme.palette.primary.dark};
    font-weight: 400;
  }
  p:first-child {
    margin-top: 0;
  }
  p:last-child {
    margin-bottom: 0;
  }
  a {
    color: ${({ theme }) => theme.palette.secondary.main};
  }
`
